/**
 * External dependencies
 */
import { createStore as reduxCreateStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createGlobalReducer } from '@naruto/naruto-reducers/src/reducers/global';
import { createMessageReducer } from '@naruto/naruto-reducers/src/reducers/message';

/**
 * Internal dependencies
 */
import { createUserReducer } from '@naruto/bgdcms/src/reducers/cores/user';
import { createAccountReducer } from '@naruto/bgdcms/src/reducers/cores/account';
import { createProjectReducer } from '@naruto/bgdcms/src/reducers/cores/project';
import { createServiceReducer } from '@naruto/bgdcms/src/reducers/cores/service';
import { createContactReducer } from '@naruto/bgdcms/src/reducers/cores/contact';
import { createSiteMetaReducer } from '@naruto/bgdcms/src/reducers/cores/site-meta';
import { createAttachmentReducer } from '@naruto/bgdcms/src/reducers/cores/attachment';
import { CreateStoreParams, Store } from './types';

function initializeStore(params: CreateStoreParams): Store {
  const { initialModel, initialMiddleWare } = params;
  return reduxCreateStore(
    combineReducers({
      global: createGlobalReducer({
        initialState: initialModel.global
      }),
      message: createMessageReducer({
        initialState: initialModel.message
      }),
      user: createUserReducer({
        initialState: initialModel.user
      }),
      account: createAccountReducer({
        initialState: initialModel.account
      }),
      project: createProjectReducer({
        initialState: initialModel.project
      }),
      service: createServiceReducer({
        initialState: initialModel.service
      }),
      contact: createContactReducer({
        initialState: initialModel.contact
      }),
      siteMeta: createSiteMetaReducer({
        initialState: initialModel.siteMeta
      }),
      attachment: createAttachmentReducer({
        initialState: initialModel.attachment
      })
    }),
    applyMiddleware(thunk.withExtraArgument({ ...initialMiddleWare }))
  );
}

export default initializeStore;
